"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInput = NumberInput;

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _fieldAlert = require("../field-alert");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _reactImask = require("react-imask");

var _typography = require("../../typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _reactForms = require("@seegno/react-forms");

var _i18n = require("@slyk/i18n");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["children", "className", "decimalPlaces", "disabled", "helpText", "id", "label", "name", "symbol", "valueType"],
    _excluded2 = ["error", "meta", "onChange", "value"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * `StyledFormControlWrapper` styled component.
 */
var StyledFormControlWrapper = (0, _styledComponents["default"])(_fieldsStyledComponents.FormControlWrapper).withConfig({
  displayName: "number-input__StyledFormControlWrapper",
  componentId: "sc-1sc7fpu-0"
})(["", ""], (0, _styledTools.ifProp)('hasChildren', (0, _styledComponents.css)(["align-items:center;display:grid;grid-column-gap:4px;grid-template-columns:max-content auto max-content;"])));
/**
 * `Symbol` styled component.
 */

var _Symbol = (0, _styledComponents["default"])(_typography.Text).attrs({
  as: 'span',
  size: 'normal'
}).withConfig({
  displayName: "number-input___Symbol",
  componentId: "sc-1sc7fpu-1"
})(["color:", ";padding:20px 0 6px 10px;pointer-events:none;transition:color ", ";", " ", ""], (0, _styles.color)('gray500'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))), _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: 14px;\n    padding-top: 22px;\n  "]))));
/**
 * `StyledFormControl` styled component.
 */


var StyledFormControl = (0, _styledComponents["default"])(_fieldsStyledComponents.FormControl).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['hasSymbol'].includes(prop);
  }
}).withConfig({
  displayName: "number-input__StyledFormControl",
  componentId: "sc-1sc7fpu-2"
})(["", ""], (0, _styledTools.ifProp)('hasSymbol', (0, _styledComponents.css)(["padding-left:0;padding-right:8px;"])));
/**
 * Parse number.
 */

function parseNumber(value) {
  if (!value) {
    return;
  }

  return parseFloat(value);
}
/**
 * Parse value.
 */


function parseValue(value, valueType) {
  switch (valueType) {
    case 'number':
      return parseNumber(value);

    default:
      return (0, _isEmpty2["default"])(value) ? undefined : value;
  }
}
/**
 * Get decimal separator by locale.
 */


function getDecimalSeparatorByLocale(locale) {
  var _formatter$formatToPa, _formatter$formatToPa2, _formatter$formatToPa3;

  var formatter = new Intl.NumberFormat(locale); // $FlowFixMe

  return (_formatter$formatToPa = (_formatter$formatToPa2 = formatter.formatToParts(0.66)) === null || _formatter$formatToPa2 === void 0 ? void 0 : (_formatter$formatToPa3 = _formatter$formatToPa2.find(function (_ref) {
    var type = _ref.type;
    return type === 'decimal';
  })) === null || _formatter$formatToPa3 === void 0 ? void 0 : _formatter$formatToPa3.value) !== null && _formatter$formatToPa !== void 0 ? _formatter$formatToPa : '.';
}
/**
 * Export `NumberInput` component.
 */


function NumberInput(props) {
  var children = props.children,
      className = props.className,
      decimalPlaces = props.decimalPlaces,
      disabled = props.disabled,
      helpText = props.helpText,
      id = props.id,
      label = props.label,
      name = props.name,
      symbol = props.symbol,
      valueType = props.valueType,
      rest = _objectWithoutProperties(props, _excluded);

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      meta = _useField.meta,
      onChange = _useField.onChange,
      value = _useField.value,
      fieldProps = _objectWithoutProperties(_useField, _excluded2);

  var _ref2 = meta || {},
      active = _ref2.active;

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmitted = _useFormState.alreadySubmitted,
      isSubmitting = _useFormState.isSubmitting;

  var _useTranslate = (0, _i18n.useTranslate)(),
      i18n = _useTranslate.i18n;

  var locale = i18n.language;
  var hasError = !!error && alreadySubmitted;
  var isDisabled = disabled || isSubmitting;
  var isFloatingLabel = Boolean(value) || active || value === 0;
  var handleChange = (0, _react.useCallback)(function (value) {
    onChange(parseValue(value, valueType));
  }, [onChange, valueType]);
  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    className: className,
    disabled: isDisabled,
    hasAlert: hasError || !!helpText
  }, /*#__PURE__*/_react["default"].createElement(StyledFormControlWrapper, {
    disabled: isDisabled,
    hasChildren: !!children,
    hasError: hasError,
    hasFocus: active
  }, /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.Label, {
    disabled: isDisabled,
    htmlFor: id !== null && id !== void 0 ? id : name,
    isFloating: symbol !== null && symbol !== void 0 ? symbol : isFloatingLabel
  }, label), symbol && /*#__PURE__*/_react["default"].createElement(_Symbol, {
    disabled: isDisabled
  }, symbol), /*#__PURE__*/_react["default"].createElement(StyledFormControl, _extends({
    as: _reactImask.IMaskInput,
    disabled: isDisabled,
    hasSymbol: symbol,
    id: id !== null && id !== void 0 ? id : name,
    inputMode: 'decimal',
    mask: Number,
    name: name,
    onAccept: handleChange,
    radix: getDecimalSeparatorByLocale(locale),
    scale: decimalPlaces,
    unmask: true,
    value: (0, _isNil2["default"])(value) ? '' : value.toString()
  }, rest, fieldProps)), children), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !hasError
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    isOpen: hasError,
    name: name
  }));
}
/**
 * Default props.
 */


NumberInput.defaultProps = {
  decimalPlaces: 0,
  valueType: 'string'
};